<template>
  <div style="display:flex;align-items:center;justify-content:center;min-height:60vh;">
    <p v-if="!error">Iniciando sesión…</p>
    <div v-else>
      <p>No fue posible iniciar sesión.</p>
      <button @click="retry">Reintentar</button>
    </div>
  </div>
</template>

<script>
import { CognitoAuth } from '@/services/Auth/cognito';
export default {
  name: 'AuthCallback',
  data: () => ({ error: false }),
  async mounted() {
    try {
      const user = await CognitoAuth.handleCallback();
      const target = (user && user.state && user.state.from) || '/';
      this.$router.replace(target);
    } catch (e) {
      console.error('Callback Cognito:', e);
      this.error = true;
    }
  },
  methods: { retry() { CognitoAuth.login({ from: '/' }); } },
};
</script>
